import React from 'react';
import { FadeInView } from '../ui/FadeInView';
import { CTAButton } from '../ui/CTAButton';
const reviews = [{
  name: 'Laura M.',
  location: 'Madrid',
  initial: 'L',
  color: 'bg-[#1B4332]',
  time: 'hace 2 semanas',
  rating: 5,
  text: 'Llevaba meses intentando comer mejor pero siempre acababa tirando la toalla. Con este megapack empecé a cocinar con la airfryer de otra manera. Las recetas son rápidas y están buenísimas. Llevo 3 semanas y no siento que esté a dieta para nada.'
}, {
  name: 'Carlos R.',
  location: 'Valencia',
  initial: 'C',
  color: 'bg-[#2D5016]',
  time: 'hace 1 mes',
  rating: 5,
  text: 'Trabajo muchas horas y no tenía tiempo para cocinar sano. El sistema de batch cooking me cambió la vida. Preparo todo el domingo y tengo comida saludable para toda la semana. Muy recomendable.'
}, {
  name: 'Ana G.',
  location: 'Barcelona',
  initial: 'A',
  color: 'bg-[#D4A853]',
  time: 'hace 3 semanas',
  rating: 5,
  text: 'Tenía la airfryer cogiendo polvo y ahora la uso todos los días. El tomo de recetas del día a día es increíble, el pollo crujiente saludable lo hago dos veces por semana. Muy contenta con la compra.'
}, {
  name: 'María T.',
  location: 'Sevilla',
  initial: 'M',
  color: 'bg-[#B8935C]',
  time: 'hace 5 días',
  rating: 5,
  text: 'Antes improvisaba siempre y acababa pidiendo comida a domicilio. Ahora tengo el menú de la semana planificado y una lista de compra clara. He bajado 3 kilos en un mes sin pasar hambre.'
}, {
  name: 'Javier P.',
  location: 'Zaragoza',
  initial: 'J',
  color: 'bg-[#1B4332]/80',
  time: 'hace 2 meses',
  rating: 5,
  text: 'Lo mejor es que no parece una dieta. Comes bien, comes rico y poco a poco ves resultados. Los postres saludables son un descubrimiento, los brownies de la airfryer están increíbles.'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-1" data-id="element-234">
      {Array.from({
      length: count
    }).map((_, i) => <svg key={i} className="w-5 h-5 fill-[#D4A853]" viewBox="0 0 24 24" data-id="element-235">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-236" />
        </svg>)}
    </div>;
}
export function TestimonialsFAQSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#F5F0E8] text-center relative overflow-hidden" data-id="element-237">
      {/* Subtle background decorative elements */}
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-238">
        <FadeInView data-id="element-239">
          {/* GOOGLE REVIEWS */}
          <div className="mb-20" data-id="element-240">
            {/* Google Reviews Header */}
            <div className="flex flex-col items-center mb-12" data-id="element-241">
              <h2 className="text-4xl md:text-5xl font-bold text-[#1B4332] mb-6 leading-tight" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-242">
                Lo que dicen otras personas
              </h2>
              <div className="flex items-center gap-4 bg-[#FAF7F2] px-8 py-4 rounded-3xl shadow-sm border border-[#D4A853]/20" data-id="element-243">
                {/* Google G logo */}
                <svg className="w-8 h-8 flex-shrink-0" viewBox="0 0 24 24" data-id="element-244">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-245" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-246" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-247" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-248" />
                </svg>
                <div className="text-left" data-id="element-249">
                  <div className="flex items-center gap-3" data-id="element-250">
                    <span className="text-3xl font-bold text-[#1B4332]" style={{
                    fontFamily: "'Playfair Display', serif"
                  }} data-id="element-251">
                      4.9
                    </span>
                    <StarRating count={5} data-id="element-252" />
                  </div>
                  <p className="text-sm text-[#2D5016]/60 font-medium" data-id="element-253">
                    Basado en 127 reseñas de Google
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6 text-left max-w-3xl mx-auto" data-id="element-254">
              {reviews.map((review, idx) => <div key={idx} className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm border border-[#D4A853]/10 hover:shadow-md transition-shadow" data-id="element-255">
                  <div className="flex items-start gap-5" data-id="element-256">
                    {/* Avatar */}
                    <div className={`${review.color} w-14 h-14 rounded-full flex items-center justify-center text-[#FAF7F2] font-bold text-2xl flex-shrink-0 shadow-sm`} style={{
                  fontFamily: "'Playfair Display', serif"
                }} data-id="element-257">
                      {review.initial}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-258">
                      <div className="flex items-center justify-between flex-wrap gap-2 mb-2" data-id="element-259">
                        <div data-id="element-260">
                          <p className="font-bold text-[#1B4332] text-lg" style={{
                        fontFamily: "'Playfair Display', serif"
                      }} data-id="element-261">
                            {review.name}
                          </p>
                          <p className="text-sm text-[#2D5016]/60 font-medium" data-id="element-262">
                            {review.location}
                          </p>
                        </div>
                        {/* Google G small */}
                        <svg className="w-5 h-5 flex-shrink-0 opacity-80" viewBox="0 0 24 24" data-id="element-263">
                          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-264" />
                          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-265" />
                          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-266" />
                          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-267" />
                        </svg>
                      </div>
                      <div className="flex items-center gap-3 mt-2 mb-4" data-id="element-268">
                        <StarRating count={review.rating} data-id="element-269" />
                        <span className="text-sm text-[#2D5016]/50 font-medium" data-id="element-270">
                          {review.time}
                        </span>
                      </div>
                      <p className="text-base text-[#1B4332]/80 leading-relaxed font-medium" data-id="element-271">
                        {review.text}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* FAQ */}
          <div className="mb-20" data-id="element-272">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B4332] mb-10 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-273">
              Preguntas frecuentes
            </h2>

            <div className="space-y-4 text-left max-w-3xl mx-auto" data-id="element-274">
              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-275">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-276">
                  ¿Necesito saber cocinar?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-277">
                  No. Las recetas están diseñadas para principiantes.
                </p>
              </div>
              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-278">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-279">
                  ¿Necesito una airfryer?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-280">
                  Sí, el método está diseñado para cocinar con airfryer.
                </p>
              </div>
              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-281">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-282">
                  ¿El material es digital?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-283">
                  Sí. Acceso inmediato desde cualquier dispositivo.
                </p>
              </div>
              <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-3xl shadow-sm border border-[#D4A853]/20 hover:shadow-md transition-shadow" data-id="element-284">
                <h3 className="text-xl font-bold text-[#1B4332] mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-285">
                  ¿Cuándo recibo el material?
                </h3>
                <p className="text-base text-[#2D5016]/80 leading-relaxed font-medium" data-id="element-286">
                  Inmediatamente después de completar la compra.
                </p>
              </div>
            </div>
          </div>

          {/* FINAL CTA */}
          <div className="bg-[#1B4332] text-[#FAF7F2] rounded-[3rem] p-10 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-287">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-[#D4A853] leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-288">
              Bajar de peso puede ser mucho más simple
            </h2>
            <div className="text-xl md:text-2xl font-medium space-y-3 mb-12 text-[#FAF7F2]/90 leading-relaxed" data-id="element-289">
              <p data-id="element-290">No necesitas dietas extremas.</p>
              <p data-id="element-291">Necesitas un sistema práctico que puedas mantener.</p>
            </div>
            <p className="text-2xl font-bold mb-10 text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-292">
              Empieza hoy mismo
            </p>
            <CTAButton href="https://pagos.digipromarket.com/products/adelgaza-con-airfryer" text="QUIERO EL MEGAPACK AHORA" data-id="element-293" />
          </div>
        </FadeInView>
      </div>
    </section>;
}